import React, { useState, useEffect } from 'react';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import styles from './SessionFormation.module.sass';
import Dropdown from '../../../../components/Dropdown';
import { showError } from '../../../../services/toast.service';

const SessionFormation = ({ sessionData, onInputChange }) => {

    // Options pour le type de session
    const sessionTypeOptions = [
        { value: 'Présentiel', label: 'Présentiel' },
        { value: 'Distanciel', label: 'Distanciel' },
        { value: 'Hybride', label: 'Hybride' }
    ];

    // Fonction pour formater la date au format PocketBase (YYYY-MM-DD HH:MM:SS)
    const formatDateForPocketBase = (dateString) => {
        if (!dateString) return '';
        // Créer la date en tant que date locale pour éviter les problèmes de fuseau horaire
        const [datePart, timePart] = dateString.split('T');
        const [year, month, day] = datePart.split('-');
        const [hours, minutes] = timePart.split(':');

        const date = new Date(year, month - 1, day, hours, minutes);

        // Formater manuellement pour éviter les conversions de fuseau horaire
        const formattedDate = date.getFullYear() + '-' +
            String(date.getMonth() + 1).padStart(2, '0') + '-' +
            String(date.getDate()).padStart(2, '0') + ' ' +
            String(date.getHours()).padStart(2, '0') + ':' +
            String(date.getMinutes()).padStart(2, '0') + ':00';

        return formattedDate;
    };

    // Gérer les changements de date avec formatage
    const handleDateChange = (field, value) => {
        const formattedDate = formatDateForPocketBase(value);

        if (field === 'start_date') {
            // Quand on définit la date de début, on met à jour la date de fin si elle n'existe pas ou si elle est antérieure
            onInputChange(field, formattedDate);

            if (!sessionData.end_date || new Date(sessionData.end_date) < new Date(formattedDate)) {
                // Ajouter 1 heure par défaut à la date de fin
                const [datePart, timePart] = value.split('T');
                const [year, month, day] = datePart.split('-');
                const [hours, minutes] = timePart.split(':');

                const startDate = new Date(year, month - 1, day, parseInt(hours), parseInt(minutes));
                startDate.setHours(startDate.getHours() + 1);

                const endDateFormatted = formatDateForPocketBase(
                    startDate.getFullYear() + '-' +
                    String(startDate.getMonth() + 1).padStart(2, '0') + '-' +
                    String(startDate.getDate()).padStart(2, '0') + 'T' +
                    String(startDate.getHours()).padStart(2, '0') + ':' +
                    String(startDate.getMinutes()).padStart(2, '0')
                );
                onInputChange('end_date', endDateFormatted);
            }
        } else if (field === 'end_date') {
            // Vérifier que la date de fin n'est pas antérieure à la date de début
            if (sessionData.start_date && new Date(formattedDate) < new Date(sessionData.start_date)) {
                // Ne pas permettre une date de fin antérieure à la date de début
                showError('La date de fin ne peut pas être antérieure à la date de début');
                return;
            }
            onInputChange(field, formattedDate);
        } else {
            onInputChange(field, formattedDate);
        }
    };

    // Gérer les changements de champs simples
    const handleInputChange = (field, value) => {
        // Si c'est le dropdown session_type, extraire la valeur string
        if (field === 'session_type' && typeof value === 'object' && value !== null) {
            onInputChange(field, value.value);
        } else {
            onInputChange(field, value);
        }
    };


    return (
        <Card
            className={styles.card}
            title="Informations de la session"
            classTitle="title-green"
        >

            <div className={styles.row}>
                <div className={styles.col}>
                    <TextInput
                        className={styles.field}
                        label="Titre de la session"
                        name="title"
                        type="text"
                        placeholder="Entrez le titre de la session"
                        value={sessionData.title || ''}
                        onChange={(e) => onInputChange('title', e.target.value)}
                        required
                    />
                </div>
            </div>

            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Date de début"
                    name="start_date"
                    type="datetime-local"
                    min={new Date().toISOString().slice(0, 10) + 'T00:00'}
                    value={sessionData.start_date ? sessionData.start_date.replace(' ', 'T').slice(0, 16) : ''}
                    onChange={(e) => handleDateChange('start_date', e.target.value)}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Date de fin"
                    name="end_date"
                    type="datetime-local"
                    min={sessionData.start_date ? sessionData.start_date.replace(' ', 'T').slice(0, 16) : ''}
                    value={sessionData.end_date ? sessionData.end_date.replace(' ', 'T').slice(0, 16) : ''}
                    onChange={(e) => handleDateChange('end_date', e.target.value)}
                    required
                />
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Type de session"
                        name="session_type"
                        options={sessionTypeOptions}
                        value={sessionTypeOptions.find(option => option.value === sessionData.session_type) || null}
                        setValue={(value) => handleInputChange('session_type', value)}
                        required
                    />
                </div>

                {sessionData.session_type === 'Présentiel' && (
                    <TextInput
                        className={styles.field}
                        label="Salle de cours"
                        name="room"
                        type="text"
                        placeholder="Numéro ou nom de la salle"
                        value={sessionData.room || ''}
                        onChange={(e) => handleInputChange('room', e.target.value)}
                        required={sessionData.session_type === 'Présentiel'}
                    />
                )}

                {sessionData.session_type === 'Distanciel' && (
                    <TextInput
                        className={styles.field}
                        label="Lien de la visio"
                        name="room_link"
                        type="text"
                        placeholder="Lien de la visio"
                        value={sessionData.room_link}
                        onChange={(e) => handleInputChange('room_link', e.target.value)}
                        required
                    />
                )}


            </div>
        </Card>
    );
};

export default SessionFormation;